//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scrollTo from 'libs/scrollTo'
import Link from 'components/mixins/Link.vue'

import { mapMutations } from 'vuex';

export default {
  block: ['text'],
  props: ['data','sharedData'],
  mixins: [
    Link,
  ],
  watch: {
    'sharedData.scrollingPosition': function(index) {
      const anchors = this.$el.querySelectorAll('[anchor]');
      const offsetTop = anchors[index].offsetTop;
      this.scrollToPos(offsetTop - 10);
    },
  },
  methods: {
    scrollToPos(YOffset){
      scrollTo(document.body, YOffset, 500);
    },
  },
  mounted() {
    this.enableScroll(this.$el.querySelector('.text'));
  }
}



// WEBPACK FOOTER //
// ./components/blocks/Text.vue